import DevicesIcon from '@atlaskit/icon/core/devices';
import * as React from 'react';

export function SvgDevices() {
  return <DevicesIcon label="" />;
}
